<template>
  <div class="product-search-page">
    <div class="subheader-wrapper">
      <div class="col" style="margin-left: -15px">
        <h2>Product Search</h2>
      </div>
      <div v-if="can('edit-products')" class="col" style="text-align: right">
        <i class="fa fa-plus" @click="addNewProduct" aria-hidden="true" style="cursor:pointer"></i>
      </div>   
    </div>  
    <hr>
    <div class="full-screen-table">
      <BasicDataGrid
        :key="productTableKey"
        :dataSource="products"
        :dataGridKey="dataGridKey"
        gridRef="productSearchGrid"
        :columns="columns"
        :actions="permissableActions"
        :showColumnLines="true"
        :searchEntireGrid="false"
        @editProduct="editProduct"
				@deleteProduct="deleteProduct"
        :multiSelect="false"
        noDataText="No Products Found.  If you believe this to be in error, please contact support@smartsalestool.app"
      />
    </div>
    <Modal ref="editProductModal" >
      <EditProductForm v-model="editedProduct" @closeProductEdit="closeProductEdit" :title="editProductTitle"/>
    </Modal>
  </div>
</template>
<script>
import BasicDataGrid    from '@/components/BasicDataGrid.vue';
import EditProductForm  from '@/components/EditProductForm.vue';

import { can }          from '@/permissions.js'

import {ProductService}   from '@/services';

export default {
  name: 'ProductSearch',
  components: {
    BasicDataGrid,
    EditProductForm
  },
  data() {
    return {
      dataGridKey: 'Id',
      productTableKey: 0,
      loading: false,
      editedProduct: {},
			editProductTitle: 'Edit Product',
      actions:[
				{
					hint: 'Edit',
					icon: 'edit',
					emit: 'editProduct',
				},
				{
					hint: 'Delete',
					icon: 'trash',
					emit: 'deleteProduct',
				},
			],
      products: [],
      columns: [
        {text: 'MFID', width: '75px', value:'MfgCode', dataType: "string"}, 
        {text: 'Part #', width: '200px', value:'PartNumber', dataType: "string"}, 
        {text: 'RefCode', width: '75px', value:'ReferenceCode', dataType: "string"}, 
        {text: 'Stock Code', width: '100px', value:'StockCode', dataType: "string"}, 
        {text: 'Description', value:'Description', dataType: "string", width: '100%'}, 
        {text: 'Retail', width: '100px', maxWidth: '150px', value:'Retail', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Dealer Cost', width: '100px', maxWidth: '150px', value:'DealerCost', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Customer Cost', width: '100px', maxWidth: '150px', value:'CustomerCost', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Min', width: '100px', maxWidth: '150px', value:'MinimumPrice', dataType: "string",
          customizeText: (cellInfo) => {
            
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        },  
        {text: 'Max', width: '100px', maxWidth: '150px', value:'MaximumPrice', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        },
      ],
    };
  },
  methods: {
    closeProductEdit(data){
			if (this.editProductTitle.includes('Add')){ 
				ProductService.create(data)
				.then(res => {
					this.updateProducts();
				})
				.catch(err => {
					const error = err.response?.data?.Message ?? 'Bad Request'
					alert('Error creating product: ' + error)
					console.log(err)
				});
			}
			else {
				ProductService.update(data)
        .then(res => {
          this.updateProducts();
        })
        .catch(err => {
					const error = err.response?.data?.Message ?? 'Bad Request'
					alert('Error updating product: ' + error)
          console.log(err)
        })
			}
		},
		updateProducts() {
      this.productTableKey++;
      // const store = this.products.store()
      // console.log('data', store )
      // // let index = this.products.map(product => {return product.id}).indexOf(this.editedProduct.Id)
      // // this.products[index] = this.editedProduct;
      this.toggleEditProductModal()
      this.editedProduct = {}
			this.editProductTitle = '';
    },
    toggleEditProductModal(){
      this.$refs.editProductModal.toggle(); 
    },
    editProduct(event){
      this.editedProduct = event.row.data
      this.editProductTitle = 'Edit Product';
      this.toggleEditProductModal()
    },
		addNewProduct(){
			this.editedProduct = {}
			this.editProductTitle = 'Add Product';
			this.toggleEditProductModal()
		},
		deleteProduct(event) {
			const deleteMessage = `Are you sure? (Delete: "${event.row.data.Description}")`
			if (confirm(deleteMessage)) {
				ProductService.delete(event.row.data.Id)
        .then(() => {
          this.getProducts();
        })
        .catch(error => {
          console.error('Error: ', error, error.message);
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error deleting: ' + error, type: 'error' });
        })
			}
		},
    getProducts(){
      this.products = ProductService.getDataSource(this.dataGridKey);
    }
  },
  computed: {
    permissableActions() {
      return can('edit-products') ? this.actions : [];
    }
  },
  created(){
    this.getProducts();
  }
};
</script>
<style lang="scss" scoped>
  .product-search-page {
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    
  }
</style>
